/* Global imports. */
import React from "react";
import { useStaticQuery, graphql } from "gatsby"
import LinkWrapper from "@components/LinkWrapper"
import { useThemeOptions } from "@src/hooks/useThemeOptions"

function SimpleNavigation() {
  const data = useStaticQuery(graphql`
  query SimpleNavigationQuery {
    allKontentItemNavigationItem(
      filter: {
        system: {
          codename: { eq: "navigation__footer_legal" }
        }
      }
    ) {
      nodes {
        elements {
          linked_item {
            value {
              id
              ... on kontent_item_template__general {
                id
                elements {
                  url_slug {
                    value
                  }
                  title {
                    value
                  }
                  short_title {
                    value
                  }
                }
              }
              ... on kontent_item_template__general_wide {
                id
                elements {
                  url_slug {
                    value
                  }
                  title {
                    value
                  }
                  short_title {
                    value
                  }
                }
              }
              ... on kontent_item_navigation_item {
                id
                elements {
                  title {
                    value
                  }
                  linked_item {
                    value {
                      id
                      ... on kontent_item_template__general {
                        id
                        elements {
                          url_slug {
                            value
                          }
                          title {
                            value
                          }
                          short_title {
                            value
                          }
                        }
                      }
                      ... on kontent_item_navigation_item {
                        id
                        elements {
                          title {
                            value
                          }
                          linked_item {
                            value {
                              id
                              ... on kontent_item_template__general {
                                id
                                elements {
                                  url_slug {
                                    value
                                  }
                                  title {
                                    value
                                  }
                                  short_title {
                                    value
                                  }
                                }
                              }
                              ... on kontent_item_navigation_item {
                                id
                                elements {
                                  title {
                                    value
                                  }
                                  linked_item {
                                    value {
                                      id
                                    }
                                  }
                                  external_url {
                                    value
                                  }
                                }
                              }
                            }
                          }
                          external_url {
                            value
                          }
                        }
                      }
                    }
                  }
                  external_url {
                    value
                  }
                }
              }
            }
          }
          external_url {
            value
          }
          title {
            value
          }
        }
      }
    }
  }
`)

const navItems = data.allKontentItemNavigationItem.nodes[0] && data.allKontentItemNavigationItem.nodes[0].elements.linked_item ? data.allKontentItemNavigationItem.nodes[0].elements.linked_item.value : null
const { footerCopyrightLine} = useThemeOptions()

return <ul className="!pl-0 !list-none">
    {navItems && navItems.map((item) => {
      if(item.elements && item.elements.external_url) {
        return <li key={item.id} className="inline-block pr-8"><a className="no-underline mb-2 text-[#767676] text-base pb-1 font-sans leading-6 inline-block relative transition-all duration-300 ease-linear hover:text-red hover:after:bottom-0 hover:after:h-[2px] hover:after:left-0 hover:after:w-full hover:after:absolute hover:after:bg-red after:transition-all after:duration-300 after:ease hover:after:scale-x-100 after:scale-x-0" href={item.elements.external_url.value}>{item.elements.short_title.value ? item.elements.short_title.value : item.elements.title.value}</a></li>
      } else { 
        return <li key={item.id} className="inline-block pr-8"><LinkWrapper cssClass="no-underline mb-2 text-[#767676] text-base pb-1 font-sans leading-6 inline-block relative transition-all duration-300 ease-linear hover:text-red hover:after:bottom-0 hover:after:h-[2px] hover:after:left-0 hover:after:w-full hover:after:absolute hover:after:bg-red after:transition-all after:duration-300 after:ease hover:after:scale-x-100 after:scale-x-0" url={`/${item.elements.url_slug.value}`} text={item.elements.short_title.value ? item.elements.short_title.value : item.elements.title.value} /></li>
      }
    })}
    {footerCopyrightLine && <li key="Footer-copyright" className="inline-block pr-8 mb-2 text-[#767676] text-base pb-1 font-sans leading-6"><span dangerouslySetInnerHTML={{ __html: footerCopyrightLine }} /></li>}
  </ul>
}

export default SimpleNavigation;
